import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FloorPlanModel } from 'app/models/floor-plan.model';

@Component({
  standalone: false,
  selector: 'app-floor-plans',
  templateUrl: './floor-plans.component.html',
  styleUrls: ['./floor-plans.component.scss']
})
export class FloorPlansComponent implements OnInit {
  public floor_plans_model: Array<FloorPlanModel>;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.subscribe(({floor_plans_model}) => {
      this.floor_plans_model = floor_plans_model;
  });
  }

}
